import {BasePanelPage} from "../../BasePanelPage";
import {BlinkInput, BlinkInputStyle} from "../../../../../ui/Input";
import {Messages} from "../../../../../Messages";
import {giftSubscriptionFlowState} from "../../../../inline-subscription/GiftSubscriptionFlowState";
import {MerchantButton} from "../../../../../common/MerchantButton";
import {TextArea} from "../../../../../../stem-core/src/ui/input/Input";
import {styleRuleInherit} from "../../../../../../stem-core/src/decorators/Style";


class BlinkTextAreaStyle extends BlinkInputStyle {
    @styleRuleInherit
    inputContainer = {
        height: 106,
    };

    @styleRuleInherit
    input = {
        padding: "12px 5px",
        overflow: "auto",
        resize: "none",
    };
}

export class GiftSubscriptionPlansPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.giftDetails,
        };
    }

    render() {
        const {giftBeneficiaryEmailAddress, name, message} = giftSubscriptionFlowState;

        return [
            <BlinkInput ref="emailInput" inputAttributes={{type: "email"}} testId="giftEmailInput"
                        label={Messages.giftEmail} onChange={() => this.redraw()}
                        initialValue={giftBeneficiaryEmailAddress}/>,
            <BlinkInput ref="nameInput" testId="giftNameInput" label={Messages.giftName}
                        onChange={() => this.redraw()} initialValue={name}/>,
            <BlinkInput ref="messageInput" testId="giftMessageInput" label={Messages.giftMessage}
                        styleSheet={BlinkTextAreaStyle} onChange={() => this.redraw()} initialValue={message}
                        InputClass={TextArea}/>,
            <MerchantButton label={Messages.continue} disabled={this.isButtonDisabled()} onClick={() => this.continue()}/>,
        ];
    }

    async continue() {
        giftSubscriptionFlowState.giftBeneficiaryEmailAddress = this.emailInput.getValue();
        giftSubscriptionFlowState.name = this.nameInput.getValue();
        giftSubscriptionFlowState.message = this.messageInput.getValue();
        await giftSubscriptionFlowState.onGiftDetailsProvided();
    }

    isButtonDisabled() {
        return !(this.emailInput?.getValue());
    }
}
